const DEV_BACKEND_PORT = process.env.REACT_APP_API_PORT || '8000';

const stripTrailingSlash = (url) => url.replace(/\/$/, '');

/**
 * API 根地址。
 * - 显式 REACT_APP_API_BASE_URL 优先（跨域拆分前后端时用）
 * - production：空串 = 同源（Express 托管 frontend/build；Genechamp / Railway 均适用）
 * - 开发：未配置时按当前 hostname 连 :8000
 */
export const resolveApiBaseUrl = () => {
	if (process.env.REACT_APP_API_BASE_URL) {
		return stripTrailingSlash(process.env.REACT_APP_API_BASE_URL);
	}
	if (process.env.NODE_ENV === 'production') {
		return '';
	}
	if (typeof window !== 'undefined' && window.location?.hostname) {
		return `${window.location.protocol}//${window.location.hostname}:${DEV_BACKEND_PORT}`;
	}
	return `http://localhost:${DEV_BACKEND_PORT}`;
};

/** @deprecated 使用 resolveApiBaseUrl；保留旧名以免引用断裂 */
export const resolveDevBackendOrigin = resolveApiBaseUrl;

/**
 * Socket.IO 连接源。
 * - REACT_APP_SOCKET_URL 优先
 * - production：当前页面 origin（同源）
 * - 开发：与 API 同源（:8000）
 */
export const resolveSocketOrigin = () => {
	if (process.env.REACT_APP_SOCKET_URL) {
		return stripTrailingSlash(process.env.REACT_APP_SOCKET_URL);
	}
	if (process.env.NODE_ENV === 'production') {
		if (typeof window !== 'undefined' && window.location?.origin) {
			return window.location.origin;
		}
		return '';
	}
	return resolveApiBaseUrl();
};

/** @deprecated 使用 resolveSocketOrigin */
export const resolveDevSocketOrigin = resolveSocketOrigin;

export const BASE_URL = resolveApiBaseUrl();

export const STATISTICS_URL = '/api/statistics';
export const DASHBOARD_URL = '/api/dashboard';
export const PRODUCTS_URL = '/api/products';
export const BRANDS_URL = '/api/brands';
export const CUSTOMERS_URL = '/api/customers';
export const USERS_URL = '/api/users';
export const ORDERS_URL = '/api/orders';
export const ORDER_DRAFTS_URL = '/api/drafts';
export const QUOTATIONS_URL = '/api/quotations';
export const APPROVALS_URL = '/api/approvals';
export const NOTIFICATIONS_URL = '/api/notifications';
export const PAYPAL_URL = '/api/config/paypal';
export const UPLOAD_URL = '/api/upload';
export const SUPPLIERS_URL = '/api/suppliers';
export const LOGIN_LOGS_URL = '/api/loginlogs';
export const ORG_DEPARTMENTS_URL = '/api/org-departments';
export const ORG_GROUPS_URL = '/api/org-groups';
export const PERMISSIONS_URL = '/api/permissions';
export const ROLE_PERMISSION_TEMPLATES_URL = '/api/role-permission-templates';
